module.exports = __webpack_public_path__ + "img/playstation.f94fdb29.gif";